import { render, staticRenderFns } from "./CustomerUsersModel.vue?vue&type=template&id=4a537654"
import script from "./CustomerUsersModel.vue?vue&type=script&lang=js"
export * from "./CustomerUsersModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports